






























import { Component, Mixins, Prop, Vue } from 'vue-property-decorator';
import MixinChartRaw from '../../../plugins/podolib/services/helper/mixins/chart/raw';

@Component
export default class ChartRunningPhaseAsymmetry extends Mixins(MixinChartRaw) {
  @Prop({ required: false, default: true }) globalType!: boolean;
  @Prop({ default: 0 }) index!: number;

  getData(side: string, data: string) {
    return this.globalType
      ? this.values.aggregates[side][data].avg
      : this.values.segments[this.index][side].result.aggregates[data].avg;
  }

  get asymmetry() {
    const leftContact = this.getData('left', 'contact_time');
    const rightContact = this.getData('right', 'contact_time');

    let substrack = (rightContact - leftContact) * 100;
    let add = (rightContact + leftContact) / 2;

    if (substrack && add) {
      const result = substrack / add;

      const isNegativeSymmetry = result < 0;
      const absResult = Math.abs(result);

      let range;
      switch (true) {
        case absResult < 2.5:
          range = 'warning';
          break;
        case absResult > 2.5 && absResult < 5:
          range = 'success';
          break;
        case absResult > 5 && absResult < 10:
          range = 'warning';
          break;
        default:
          range = 'error';
      }

      const left = isNegativeSymmetry ? 50 + absResult : 50 - absResult;
      const right = isNegativeSymmetry ? 50 - absResult : 50 + absResult;
      const leftProgress = absResult * 2.5;
      const rightProgress = absResult * 2.5;

      return {
        range: range,
        value: parseFloat((absResult / 2).toFixed(absResult / 2 < 1 ? 1 : 0)),
        leftProgress: leftProgress,
        rightProgress: rightProgress,
        isLeftSideSymmetry: left > right,
      };
    } else {
      return {
        range: 'ok',
        left: 0,
        right: 0,
        leftProgress: 50,
        rightProgress: 50,
        isLeftSideSymmetry: false,
      };
    }
  }
}
